// Devias Kit inspired color palette
export const neonBlue = {
  50: '#ecf0ff',
  100: '#dde3ff',
  200: '#c2cbff',
  300: '#9ca7ff',
  400: '#7578ff',
  500: '#635bff',
  600: '#4e36f5',
  700: '#432ad8',
  800: '#3725ae',
  900: '#302689',
};

export const stormGrey = {
  50: '#f9fafb',
  100: '#f1f1f4',
  200: '#dcdfe4',
  300: '#b3b9c6',
  400: '#8a94a6',
  500: '#667085',
  600: '#565e73',
  700: '#434a60',
  800: '#313749',
  900: '#212636',
};

export const kepple = {
  500: '#15b79f',
  600: '#0e9382',
};

export const redOrange = {
  500: '#f04438',
};

export const california = {
  500: '#fb9c0c',
};

export const shakespeare = {
  500: '#04aad6',
};
